import { render, staticRenderFns } from "./RejectReasons.vue?vue&type=template&id=63022593&scoped=true"
import script from "./RejectReasons.vue?vue&type=script&lang=js"
export * from "./RejectReasons.vue?vue&type=script&lang=js"
import style0 from "./RejectReasons.vue?vue&type=style&index=0&id=63022593&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63022593",
  null
  
)

export default component.exports